  function delayScrollAnime() {
    var timeStep = 0.2; // 1要素ごとの追加ディレイ秒
    $(".js-scroll").each(function () {
      var parent = this;
      // すでに一度発火したらスキップ
      if ($(parent).hasClass("is-animated")) return;

      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();

      // トリガー閾値（統一: 15%）
      var triggerOffset = windowHeight * 0.15;

      if (scroll >= elemPos - windowHeight + triggerOffset) {
        var value = timeStep;
        var childs = $(this).children();
        $(this).css("opacity", 1); // 親は見える状態へ
        $(childs).each(function () {
          $(this).css("animation-delay", value + "s");
          $(this).addClass("fadeUp");
          value += timeStep;
        });
        $(parent).addClass("is-animated"); // 一度だけ
      }
    });
  }

  // スクロール・ロード時（間引き）
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () {
        delayScrollAnime();
        ticking = false;
      });
    }
  }
  $(window).on("scroll", onScroll);
  $(window).on("load", function () {
    delayScrollAnime();
  });

  // ========== 2) シンプルなフェード（show-fade） ==========
  function simpleFade() {
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    var triggerOffset = windowHeight * 0.15; // 統一: 15%

    $(".fade").each(function () {
      var imgPos = $(this).offset().top;
      if (scroll > imgPos - windowHeight + triggerOffset) {
        $(this).addClass("show-fade");
        // 繰り返し不要なら属性やフラグを付けて二度目以降の処理を避けてもOK
      }
    });
  }
  $(window).on("scroll", function () {
    requestAnimationFrame(simpleFade);
  });
  $(window).on("load", simpleFade);

  // ========== 3) 画像イン（show-img）SP/PC閾値切り替え ==========
  function imgIn() {
    var winW = $(window).width();
    var showH = winW <= 767 ? 100 : 300; // SP/PCで閾値を変更
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();

    $(".img-in img").each(function () {
      var imgPos = $(this).offset().top;
      if (scroll > imgPos - windowHeight + showH) {
        $(this).addClass("show-img");
      } else {
        // 一度だけなら外さない
        // $(this).removeClass("show-img");
      }
    });
  }
  $(window).on("scroll", function () {
    requestAnimationFrame(imgIn);
  });
  $(window).on("load resize", imgIn);

  // ========== 4) inViewトリガー（個別解除で統一） ==========
  inView.offset(0.15 * window.innerHeight); // 15%入ったら

  inView('[data-inview]')
    .on('enter', el => {
      el.classList.add('is-inview');
      // 個別に二度目以降のトリガーを避ける
      el.removeAttribute('data-inview');
    })
    .on('exit', el => {
      // 繰り返し表示したい場合は必要に応じて解除
      // el.classList.remove('is-inview');
    });

  // data-delay属性で遅延指定（ms）
  document.querySelectorAll('.fade-in[data-delay]').forEach(el => {
    const d = parseInt(el.getAttribute('data-delay'), 10);
    if (!Number.isNaN(d)) {
      el.style.transitionDelay = d + 'ms';
    }
  });

  // 画面サイズ変更時のoffset再計算
  window.addEventListener('resize', () => {
    inView.offset(0.15 * window.innerHeight);
  });


  //GSAP
document.addEventListener('DOMContentLoaded', function () {
  var title = document.querySelector('.p-mainv__txt h1');
  var text = document.querySelector('.p-mainv__txt p');
  var buttons = document.querySelectorAll('.p-mainv-bnr .c-btn');
  var splash = document.getElementById('splash');

  if (!title || !text || typeof gsap === 'undefined') return;

  function animateMainVisualText() {
    if (animateMainVisualText.done) return;
    animateMainVisualText.done = true;

    // SplitType
    var splitTitle = new SplitType(title, { types: 'chars, words' });
    var splitText = new SplitType(text, { types: 'lines, words' });

    // lineのwrapperが必要なケース向けにopacity初期化
    gsap.set(title, { opacity: 1 });
    gsap.set(text, { opacity: 1 });

    // 初期状態
    gsap.set(splitTitle.chars, {
      opacity: 0,
      y: 40,
      rotateX: -80,
      transformOrigin: '0% 50% -50',
      filter: 'blur(8px)'
    });

    gsap.set(splitText.words, {
      opacity: 0,
      y: 24,
      filter: 'blur(6px)'
    });

    gsap.set(buttons, {
      opacity: 0,
      y: 20,
      scale: 0.96
    });

    var tl = gsap.timeline({
      defaults: {
        ease: 'power3.out'
      }
    });

    tl.to(splitTitle.chars, {
      opacity: 1,
      y: 0,
      rotateX: 0,
      filter: 'blur(0px)',
      duration: 1.05,
      ease: 'power4.out',
      stagger: {
        each: 0.055,
        from: 'start'
      }
    })
    .to(splitText.words, {
      opacity: 1,
      y: 0,
      filter: 'blur(0px)',
      duration: 0.8,
      stagger: {
        each: 0.025,
        from: 'start'
      }
    }, '-=0.7')
    .to(buttons, {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: 0.8,
      stagger: 0.12,
      ease: 'power2.out'
    }, '-=0.35');
  }

  if (!splash) {
    animateMainVisualText();
    return;
  }

  window.addEventListener('splash:finished', animateMainVisualText, { once: true });
});

document.addEventListener('DOMContentLoaded', function () {
  if (typeof gsap === 'undefined' || typeof SplitType === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  document.querySelectorAll('.c-gsap-head').forEach(function (target) {
    var split = new SplitType(target, { types: 'chars' });

    split.chars.forEach(function (char) {
      var wrap = document.createElement('span');
      wrap.className = 'char-wrap';
      char.parentNode.insertBefore(wrap, char);
      wrap.appendChild(char);
    });

    gsap.set(split.chars, {
      yPercent: 110
    });

    gsap.to(split.chars, {
      yPercent: 0,
      duration: 0.85,
      ease: 'power4.out',
      stagger: 0.045,
      scrollTrigger: {
        trigger: target,
        start: 'top 80%',
        once: true
      }
    });
  });
});

//parallax
gsap.registerPlugin(ScrollTrigger);

window.addEventListener('load', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.log('GSAP or ScrollTrigger が未読み込み');
    return;
  }

  const parallaxSections = document.querySelectorAll('.js-main-parallax');

  if (!parallaxSections.length) {
    console.log('.js-main-parallax が見つかりません');
    return;
  }

  parallaxSections.forEach((section) => {
    const image = section.querySelector('.c-pal__main-imgs img');

    if (!image) {
      console.log('対象画像が見つかりません:', section);
      return;
    }

    gsap.fromTo(
      image,
      {
        yPercent: -8,
        scale: 1.2
      },
      {
        yPercent: 8,
        scale: 1.2,
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1
          // markers: true
        }
      }
    );
  });
});

//文字のinview
document.addEventListener('DOMContentLoaded', function () {
  const targets = document.querySelectorAll('.js-inview');

  const observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('inview');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2
  });

  targets.forEach(function (target) {
    observer.observe(target);
  });
});